import { render, staticRenderFns } from "./AddCustomer.vue?vue&type=template&id=c1eb2718&scoped=true"
import script from "./AddCustomer.vue?vue&type=script&lang=js"
export * from "./AddCustomer.vue?vue&type=script&lang=js"
import style0 from "./AddCustomer.vue?vue&type=style&index=0&id=c1eb2718&prod&scoped=true&lang=css"
import style1 from "./AddCustomer.vue?vue&type=style&index=1&id=c1eb2718&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1eb2718",
  null
  
)

export default component.exports